import SubmissionTranslator from "../../../utils/SubmissionTranslator";

const translator = new SubmissionTranslator("medical");

// Order of columnSchema must match order of columnDetails
export const columnSchema = {
  date_of_service: null,
  ndc_11: null,
  quantity: null,
  rendering_physician_id: null,
  service_provider_id: null,
  id_340b_raw: null,
  health_plan_id: null,
  health_plan_name: null,
  claim_number: null,
  claim_line_number: null,
  hcpcs_code: null,
  hcpcs_code_modifier_1: null,
  hcpcs_code_modifier_2: null,
  hcpcs_code_modifier_3: null,
  hcpcs_code_modifier_4: null,
  unit_of_measure: null,
  wholesaler_invoice_number: null,
  formatted_claim_number: null,
};

export const columnDetails = [
  {
    name: "date_of_service",
    title: translator.getTitle("date_of_service"),
    label: translator.getLabel("date_of_service"),
    description: translator.getDescription("date_of_service"),
    required: true,
    order: 1,
  },
  {
    name: "ndc_11",
    title: translator.getTitle("ndc_11"),
    label: translator.getLabel("ndc_11"),
    description: translator.getDescription("ndc_11"),
    required: true,
    order: 2,
  },
  {
    name: "quantity",
    title: translator.getTitle("quantity"),
    label: translator.getLabel("quantity"),
    description: translator.getDescription("quantity"),
    required: true,
    order: 3,
  },
  {
    name: "rendering_physician_id",
    title: translator.getTitle("rendering_physician_id"),
    label: translator.getLabel("rendering_physician_id"),
    description: translator.getDescription("rendering_physician_id"),
    required: false,
    order: 4,
  },
  {
    name: "service_provider_id",
    title: translator.getTitle("service_provider_id"),
    label: translator.getLabel("service_provider_id"),
    description: translator.getDescription("service_provider_id"),
    required: true,
    order: 5,
  },
  {
    name: "id_340b_raw",
    title: translator.getTitle("id_340b_raw"),
    label: translator.getLabel("id_340b_raw"),
    description: translator.getDescription("id_340b_raw"),
    required: true,
    order: 6,
  },
  {
    name: "health_plan_id",
    title: translator.getTitle("health_plan_id"),
    label: translator.getLabel("health_plan_id"),
    description: translator.getDescription("health_plan_id"),
    required: true,
    order: 7,
  },
  {
    name: "health_plan_name",
    title: translator.getTitle("health_plan_name"),
    label: translator.getLabel("health_plan_name"),
    description: translator.getDescription("health_plan_name"),
    required: true,
    order: 8,
  },
  {
    name: "claim_number",
    title: translator.getTitle("claim_number"),
    label: translator.getLabel("claim_number"),
    description: translator.getDescription("claim_number"),
    required: true,
    order: 9,
  },
  {
    name: "claim_line_number",
    title: translator.getTitle("claim_line_number"),
    label: translator.getLabel("claim_line_number"),
    description: translator.getDescription("claim_line_number"),
    required: true,
    order: 10,
  },
  {
    name: "hcpcs_code",
    title: translator.getTitle("hcpcs_code"),
    label: translator.getLabel("hcpcs_code"),
    description: translator.getDescription("hcpcs_code"),
    required: false,
    order: 11,
  },
  {
    name: "hcpcs_code_modifier_1",
    title: translator.getTitle("hcpcs_code_modifier_1"),
    label: translator.getLabel("hcpcs_code_modifier_1"),
    description: translator.getDescription("hcpcs_code_modifier_1"),
    required: false,
    order: 12,
  },
  {
    name: "hcpcs_code_modifier_2",
    title: translator.getTitle("hcpcs_code_modifier_2"),
    label: translator.getLabel("hcpcs_code_modifier_2"),
    description: translator.getDescription("hcpcs_code_modifier_2"),
    required: false,
    order: 13,
  },
  {
    name: "hcpcs_code_modifier_3",
    title: translator.getTitle("hcpcs_code_modifier_3"),
    label: translator.getLabel("hcpcs_code_modifier_3"),
    description: translator.getDescription("hcpcs_code_modifier_3"),
    required: false,
    order: 14,
  },
  {
    name: "hcpcs_code_modifier_4",
    title: translator.getTitle("hcpcs_code_modifier_4"),
    label: translator.getLabel("hcpcs_code_modifier_4"),
    description: translator.getDescription("hcpcs_code_modifier_4"),
    required: false,
    order: 15,
  },
  {
    name: "unit_of_measure",
    title: translator.getTitle("unit_of_measure"),
    label: translator.getLabel("unit_of_measure"),
    description: translator.getDescription("unit_of_measure"),
    required: false,
    order: 16,
  },
  {
    name: "wholesaler_invoice_number",
    title: translator.getTitle("wholesaler_invoice_number"),
    label: translator.getLabel("wholesaler_invoice_number"),
    description: translator.getDescription("wholesaler_invoice_number"),
    required: false,
    order: 17,
  },
];

export const computedColumns = ["formatted_claim_number"];

export const tableHeaders = columnDetails.sort((a, b) => a.order - b.order).map((col) => col.name);
export const sortedColumnDetails = columnDetails.sort((a, b) => a.order - b.order);
export const required = columnDetails.filter((col) => col.required).map((col) => col.name);
export const notRequired = columnDetails.filter((col) => !col.required).map((col) => col.name);

export const isRequiredField = (column) => required.includes(column);

export const columnNameAliases = {
  date_of_service: [
    "Date Of Service",
    "Fill Date",
    "Dispensed",
    "Fill Sold Date",
    "Service Date",
    "Date of Service (Fill Date)",
    "Rx Fill Date",
    "DOS (Date of Service)",
    "Date Filled",
    "Dispense Date",
  ],
  ndc_11: [
    "Dispensed Item NDC",
    "Dispensed NDC",
    "Dispensed NDC11",
    "NDC",
    "NDC 11",
    "NDC Number",
    "NDC-11",
    "Product",
    "Product Service ID",
    "Service ID",
  ],
  quantity: [
    "Quantity",
    "Qty Disp",
    "Qnty",
    "Qty Dispensed",
    "Qty",
    "Dispensed Quantity",
    "Dispense Qty",
    "Billed HCPCS Quantity",
  ],
  rendering_physician_id: [
    "Prescriber ID",
    "prescriber npi",
    "Prescriber DEA",
    "PrescriberNPIorDEA",
    "Prescriber NPI Or Dea",
    "Rendering Physician NPI",
    "Rendering Physician ID",
  ],
  service_provider_id: [
    "Service Provider ID",
    "Service Provider ID NPI",
    "Pharmacy #",
    "Service Provider ID NCPDP_NABP",
    "Pharmacy DEA",
    "Ph NCPDP",
    "Pharmacy NCPDP",
    "Pharmacy NPI",
    "Prescriber NPI",
    "facility_opa_340b_id",
    "Store NPI",
    "Service Provider NPI",
  ],
  id_340b_raw: [
    "Contracted Entity ID",
    "Contracted Entity",
    "CE ID",
    "Entity ID",
    "OPA Code",
    "HRSA #",
    "id340b",
    "340bid",
  ],
  health_plan_id: [
    "Plan ID Code",
    "Health Plan ID",
    "Plan Identifier",
    "Participant Name ID",
    "Client Member ID",
  ],
  health_plan_name: ["Plan Name", "Health Plan Name"],
  claim_number: [
    "Claim Number",
    "Claim ID",
    "Claim Unique ID",
    "Scrambled ID",
    "Claim Original ID",
  ],
  claim_line_number: ["Claim Line Number", "Line Number", "Internal Claim ID", "Line No"],
  hcpcs_code: ["HCPCS Code", "HCPC Code", "HCPC CD", "J Code"],
  hcpcs_code_modifier_1: ["HCPCS Code Modifier 1", "J Code Modifier 1", "HCPC Modifier"],
  hcpcs_code_modifier_2: ["HCPCS Code Modifier 2", "J Code Modifier 2"],
  hcpcs_code_modifier_3: ["HCPCS Code Modifier 3", "J Code Modifier 3"],
  hcpcs_code_modifier_4: ["HCPCS Code Modifier 4", "J Code Modifier 4"],
  unit_of_measure: ["Billed HCPCS Unit of Measure", "Unit of Measure", "HCPC Unit of Measure"],
  wholesaler_invoice_number: [
    "Wholesaler Invoice Number",
    "Wholesaler PO",
    "Invoice Number",
    "Wholesaler Invoice #",
    "Invoice #",
    "replenished order number",
  ],
};
